import { Button, DataSource, Layout, SearchPanel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTransmissionControlList extends Layout {
    buttonAddRecovery: Button;
    buttonBypassBatch: Button;
    buttonRetransmit: Button;
    buttonSearchText: Button;
    buttonViewRecovery: Button;
    panelSearch: SearchPanel;
    sourceTransmissionControlList: DataSource;
    switchIntercompany: Switch;
    tableTransmissions: Table;
    textboxAS2MessageID: Textbox;
    textboxBatch: Textbox;
    textboxCompany: Textbox;
    textboxCreateDate: Textbox;
    textboxDate: Textbox;
    textboxDescr: Textbox;
    textboxDirection: Textbox;
    textboxFilename: Textbox;
    textboxFuncBatch: Textbox;
    textboxFuncReceiverID: Textbox;
    textboxFuncSenderID: Textbox;
    textboxFuncVersion: Textbox;
    textboxID: Textbox;
    textboxIntReceiverID: Textbox;
    textboxIntVersion: Textbox;
    textboxInternalFilename: Textbox;
    textboxLogName: Textbox;
    textboxNumchars: Textbox;
    textboxPartnerName: Textbox;
    textboxSenderID: Textbox;
    textboxStatus: Textbox;
    textboxSuccessful: Textbox;
    textboxTemplateID: Textbox;
    textboxTextSearch: Textbox;
    textboxTotalGroups: Textbox;
    textboxTransactionType: Textbox;
    textboxTransmissionID: Textbox;
}
